import React, { Component } from "react";

class CarouselCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carousel: {
        id: this.props.id,
        imgUrl: this.props.carousel.imgUrl,
        image:null,
        redirectUrl: this.props.carousel.redirectUrl,
        imgTitle: this.props.carousel.imgTitle,
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  handleChange(e) {
    let { name, value } = e.target;
    let carousel = { ...this.state.carousel };
    carousel[name] = value;
    this.setState({
      carousel: carousel,
    }); 
  }

  handleUpload(e) {
    let carousel = { ...this.state.carousel };
    carousel[e.target.name] = e.target.files[0];
    this.setState({ carousel: carousel });
  }

  render() {
    let carousel = this.state.carousel;
    return (
      <React.Fragment>
        <div className="col-sm-4 mt-2">
          <div
            className="card"
            style={{ border: "2px solid rgba(0,0,0,.125)" }}
          >
            <div className="card-body">
              <h5 className="card-title">Title: {carousel.imgTitle}</h5>

              <div className="m-2">
                <img
                  src={carousel.imgUrl}
                  title="carousel Logo"
                  style={{ width: "100%", height: "120px" }}
                />
              </div>
              <p className="card-text">
                <b>Redirect:</b> {carousel.redirectUrl}
              </p>
              <button
                href="#"
                className="btn btn-primary m-0 p-0 px-2 mr-2"
                data-toggle="modal"
                data-target={`#cpe${this.props.id}`}
                // onClick={() => this.props.setCouponId(props.id)}
              >
                Edit
              </button>
              {/* ------------------------------------ Edit carousel Modal starts ------------------------------------*/}
              <div
                className="modal fade bd-example-modal-lg"
                id={`cpe${this.props.id}`}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Edit and Save the details
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <form
                        onSubmit={(e) =>
                          this.props.handleEditSubmit(e, this.state.carousel)
                        }
                      >
                        <div className="row mx-4">
                          <div class="form-group col-md-6">
                            <label for="imagetitle">Image Title</label>
                            <input
                              name="imgTitle"
                              type="text"
                              id="imagetitle"
                              className="form-control"
                              value={carousel.imgTitle}
                              onChange={this.handleChange}
                              placeholder="Enter Image Title"
                              required
                            />
                          </div>
                          <div class="form-group col-md-6">
                            <label for="imageurlbrand">Upload Image</label>
                            <input
                              name="image"
                              type="file"
                              id="imageurlbrand"
                              className="form-control"
                              onChange={this.handleUpload}
                              accept=".png,.jpeg, .jpg, .webp"
                            />
                          </div>
                        </div>
                        <div className="row mx-4">
                          <div class="form-group col-md-8">
                            <label for="redirect">Redirect Url</label>
                            <input
                              name="redirectUrl"
                              type="text"
                              id="redirect"
                              className="form-control"
                              placeholder="Enter Redirect Url"
                              onChange={this.handleChange}
                              value={carousel.redirectUrl}
                              required
                            />
                          </div>
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              id={carousel.id}
                              disabled={this.props.carouselBtnLoading}
                            >
                              {this.props.carouselBtnLoading
                                ? "Saving"
                                : "Save"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* ------------------------------------ Edit carousel Modal ends ------------------------------------*/}
              {/* {props.isAdmin ? ( */}
              <button
                href="#"
                className="btn btn-secondary m-0 p-0 px-2"
                data-toggle="modal"
                data-target={`#cpd${this.props.id}`}
              >
                Delete
              </button>
              {/* ) : null} */}

              {/* ------------------------------------ Delete carousel Modal starts ------------------------------------*/}
              <div
                className="modal fade"
                id={`cpd${this.props.id}`}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Irreversible Operation
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete{" "}
                        <b>{carousel.imgTitle}</b>
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={(e) =>
                          this.props.handleDeleteCarousel(e, carousel)
                        }
                        disabled={this.props.deleteBtnLoading}
                      >
                        {this.props.deleteBtnLoading ? "Deleting" : "Delete"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* ------------------------------------ Delete carousel Modal ends ------------------------------------*/}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CarouselCard;
